import React, { ButtonHTMLAttributes } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'icon' | 'new-chat' | 'login';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  isLoading?: boolean;
  children: React.ReactNode;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  isLoading = false,
  children,
  className = '',
  disabled,
  ...rest
}) => {
  return (
    <button
      className={`btn btn--${variant} ${className}`}
      disabled={isLoading || disabled}
      {...rest}
    >
      {isLoading ? (
        <>
          <div className="loading__dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button; 